import styled from 'styled-components'

type Props = {
  discountApplied?: boolean;
}

const StyledOrderItem = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  grid-gap: 3rem;

  .item-details-container {
    display: flex;

    .item-preview-image {
      height: 37px;
      width: 56px;
      margin-right: 1rem;
      position: relative;
      border-radius: 3px;
      flex-shrink: 0;

      img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        border-radius: 3px;
        object-fit: cover;
      }

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        border-radius: 3px;
        border: 1px solid #00000021;
      }
    }

    .item-details {
      display: grid;
      grid-gap: 5px;
      line-height: 24px;

      .item-label {
        color: ${({ theme }) => theme.colors.gray[700]};
      }

      .item-sub-label {
        color: ${({ theme }) => theme.colors.gray[400]};
        font-size: 13px;
      }
    }
  }

  b {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray[700]};
    font-size: 20px;
    text-decoration: ${({ discountApplied }) => (discountApplied ? 'line-through' : '')};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};
  }
`

export default StyledOrderItem
